import {
    Typography, Button, Icon, Box,
    CardActions, CardContent, CardMedia
} from '@mui/material'

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { generateUrl } from '@services/routes'
import { ROUTE_LANDING_ZONES_ID_MODE } from '@features/routes'

import LandingZoneMigrationApi from '@api/landingZones/migration'

import Tile from '@components/Tile'

import azureLogo from './media/azureLogo.png'
import awsLogo from './media/awsLogo.png'

const migrationConfig = {
    notMigrated: { label: 'Firewall migration', icon: 'sync_alt', variant: 'secondary', color: 'primary', clickable: true },
    inProgress: { label: 'Migration in progress', icon: 'sync', variant: 'secondary', color: 'primary', clickable: true, iconSx: { animation: 'spin 1.5s linear infinite', '@keyframes spin': { '0%': { transform: 'rotate(0deg)' }, '100%': { transform: 'rotate(360deg)' } } } },
    migrated: { label: 'Firewall migrated', icon: 'check_circle', variant: 'outlined', color: 'success' }
}

const AzureFirewallMigration = ({ id, onClick }) => {
    const [migrationState, setMigrationState] = useState(null)

    useEffect(() => {
        LandingZoneMigrationApi.migrationStatus(id, {
            success: (result) => {
                const status = result?.data?.data?.status ?? 'NOT_MIGRATED'
                if (status === 'MIGRATED') setMigrationState('migrated')
                else if (status === 'NOT_MIGRATED') setMigrationState('notMigrated')
                else setMigrationState('inProgress')
            },
            error: () => { }
        })
    }, [id])

    if (!migrationState) return null

    const config = migrationConfig[migrationState]

    return (
        <Button
            variant={config.variant}
            color={config.color}
            onClick={config.clickable ? onClick : undefined}
            startIcon={<Icon sx={config.iconSx}>{config.icon}</Icon>}
            disableRipple={!config.clickable}
            sx={{ width: '100%', ...(!config.clickable && { pointerEvents: 'none' }) }}
        >
            {config.label}
        </Button>
    )
}

export const LzCard = ({ id, azure, aws, needMigration, subscription }) => {
    let logo = azureLogo
    if (azure) logo = azureLogo
    if (aws) logo = awsLogo

    const navigate = useNavigate()

    const handleMigration = () => {
        if (azure) {
            navigate(generateUrl(ROUTE_LANDING_ZONES_ID_MODE, { id, mode: 'firewall-migration' }))
        }
    }

    const handleSettings = () => {
        if (id) navigate(generateUrl(ROUTE_LANDING_ZONES_ID_MODE, { id: id, mode: 'groups' }))
    }

    return (
        <Tile sx={{ width: '240px', padding: 0 }}>
            <Box onClick={handleSettings} sx={{ cursor: 'pointer' }}>
                <CardMedia
                    sx={{ borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                    component={'img'}
                    alt={id}
                    height={'140'}
                    image={logo}
                />
                <CardContent>
                    <Typography variant="h4">{id}</Typography>
                </CardContent>
            </Box>
            {!aws && needMigration && subscription && (
                <CardActions sx={{ paddingBottom: '16px' }}>
                    <AzureFirewallMigration id={id} onClick={handleMigration} />
                </CardActions>
            )}
        </Tile>
    )
}

export default LzCard